import { render, staticRenderFns } from "./BundleDiscountGroupList.vue?vue&type=template&id=dfb5aa2c&scoped=true&"
import script from "./BundleDiscountGroupList.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./BundleDiscountGroupList.vue?vue&type=style&index=0&id=dfb5aa2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb5aa2c",
  null
  
)

export default component.exports